@if(loadingiframeUrl)
{
<div>
  <div class="snappayloading">
    <!-- Processing Graphic -->
    <div class="lds-css ng-scope">
      <div class="lds-spin">
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
        <div>
          <div></div>
        </div>
      </div>
    </div>
    <span class="sr-only">Loading</span>
    <!-- End Processing Graphic -->
  </div>
</div>
}
<div name="form" [ngClass]="{'d-none' : loadingiframeUrl}">
  <div class="cccardlabelwrapper paymentpage-block">
    <label for="ccnumfield" class="cccardlabel" id="cccardlabel">Card Number</label>
    <div class="iframe-snappay">
      @if(iframeURL)
      {
        <iframe [src]="iframeURL" class="iframe" title="Credit Card Collection"></iframe>
      }
    </div>
  </div>
  <div class="iframe-snappay-expdate paymentpage-block">
    <label for="ccexpirymonth" id="ccexpirylabel">Expiration Date</label>
    <div>
      <span class="exp-month-wrapper">
        <kendo-dropdownlist name="months"
                            id="months"
                            [data]="months"
                            [valueField]="'value'"
                            [textField]="'text'"
                            [(value)]="selected_month"
                            [(ngModel)]="selected_month"
                            [valuePrimitive]="true"
                            [required]="true"
                            [style.width.px]="50"
                            [popupSettings]="{width: 50, appendTo: 'root'}">
          <ng-template kendoDropDownListNoDataTemplate>
            <h4><span class="k-icon k-i-warning"></span><br /><br />Unable to retrieve data</h4>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            @if(!dataItem?.value)
            {
              <span>--</span>
            }
            @if(dataItem?.value)
            {
              <span class="template">{{ dataItem?.text }}</span>
            }
          </ng-template>
        </kendo-dropdownlist>
      </span>
      <span class="exp-years-wrapper offset-1">
        <kendo-dropdownlist name="years"
                            id="years"
                            [data]="years"
                            [valueField]="'value'"
                            [textField]="'text'"
                            [(value)]="selected_year"
                            [(ngModel)]="selected_year"
                            [valuePrimitive]="true"
                            [required]="true"
                            [style.width.px]="75"
                            [popupSettings]="{width: 75, appendTo: 'root'}">
          <ng-template kendoDropDownListNoDataTemplate>
            <h4><span class="k-icon k-i-warning"></span><br /><br />Unable to retrieve data</h4>
          </ng-template>
          <ng-template kendoDropDownListValueTemplate let-dataItem>
            @if(!dataItem?.value)
            {
            <span>--</span>
            }
            @if(dataItem?.value)
            {
            <span class="template">{{ dataItem?.text }}</span>
            }
          </ng-template>
        </kendo-dropdownlist>
      </span>
    </div>
  </div>
  <div class="iframe-snappay-cvv paymentpage-block">
    <label for="cccvvfield" id="cccvvlabel">CVV</label>
    <div class="d-flex justify-content-center">
      <kendo-numerictextbox [spinners]="false"
                            [(ngModel)]="cvv"
                            [required]="true"
                            [format]="'###'"
                            name="txtBoxNamecvv"
                            id="txtBoxIdcvv"
                            class="input-number textbox-cvv"
                            [autoCorrect]="false">
      </kendo-numerictextbox>
    </div>
  </div>
</div>

